/* ==========================================================================
   The Pure Beauty — JS global du thème TPB 2026
   - TPB.money()            : formatage des prix (format monétaire de la boutique)
   - TPB.cart               : Ajax Cart API + Section Rendering API (tiroir panier)
   - [data-tpb-add]         : boutons « ajouter au panier » déclaratifs
   - form[data-tpb-product-form] : formulaires produit en Ajax
   - <tpb-cart-drawer>      : tiroir panier
   - <tpb-slider>           : sliders scroll-snap (flèches + pastilles + filtres)
   - <tpb-sticky-atc>       : barre d'ajout au panier collante
   - <tpb-shipping-estimator> : estimation de la date de livraison
   - <tpb-header>           : menu mobile + menu déroulant
   ========================================================================== */
(function () {
  'use strict';

  var config = window.TPB_CONFIG || { routes: {}, strings: {} };
  var TPB = (window.TPB = window.TPB || {});
  TPB.config = config;


  /* ---------- Utilitaires ---------- */
  TPB.money = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || config.moneyFormat || '{{amount_with_comma_separator}} €';
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = typeof thousands === 'undefined' ? ',' : thousands;
      decimal = typeof decimal === 'undefined' ? '.' : decimal;
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount_with_comma_separator') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2, '.', ',');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value).replace(/<[^>]*>/g, '');
  };

  TPB.debounce = function (fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  };

  TPB.addWorkingDays = function (days) {
    var d = new Date();
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) added++;
    }
    return d;
  };

  TPB.frDate = function (d) {
    return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' }).replace('.', '');
  };

  /* ---------- Panier (Ajax Cart API) ---------- */
  var CART_SECTION = 'tpb-cart-drawer';
  // Les appels panier du thème passent par le fetch natif : seuls ceux des apps tierces
  // (ex. EG Auto Add to Cart, qui ajoute les produits offerts) sont interceptés plus bas.
  var nativeFetch = window.fetch.bind(window);

  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('[data-cart-section-id]').forEach(function (el) {
      var id = el.getAttribute('data-cart-section-id');
      if (id && ids.indexOf(id) < 0) ids.push(id);
    });
    if (!ids.length) ids.push(CART_SECTION);
    return ids;
  }

  function postJSON(url, body) {
    return window.fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) {
          var err = new Error(data.description || data.message || config.strings.error);
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  TPB.cart = {
    sectionIds: cartSectionIds,

    get: function () {
      return nativeFetch((config.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    },

    /**
     * Ajoute un ou plusieurs articles.
     * @param {Array<{id:number, quantity?:number, properties?:object}>} items
     * @param {{open?:boolean}} options
     */
    add: function (items, options) {
      options = options || {};
      items = (Array.isArray(items) ? items : [items]).map(function (it) {
        return { id: Number(it.id), quantity: Number(it.quantity || 1), properties: it.properties || undefined };
      });
      return postJSON((config.routes.cartAdd || '/cart/add') + '.js', {
        items: items,
        sections: cartSectionIds().join(','),
        sections_url: window.location.pathname
      }).then(function (data) {
        if (config.cartType === 'page') {
          window.location.href = config.routes.cart || '/cart';
          return data;
        }
        TPB.cart.renderSections(data.sections);
        TPB.cart.syncCount();
        document.dispatchEvent(new CustomEvent('tpb:cart:added', { detail: { items: items, response: data } }));
        if (options.open !== false) TPB.cart.open();
        TPB.cart.verifyLater();
        return data;
      });
    },

    change: function (key, quantity) {
      return postJSON((config.routes.cartChange || '/cart/change') + '.js', {
        id: key,
        quantity: quantity,
        sections: cartSectionIds().join(','),
        sections_url: window.location.pathname
      }).then(function (data) {
        TPB.cart.renderSections(data.sections);
        TPB.cart.updateCount(data.item_count);
        TPB.cart.remember(data);
        document.dispatchEvent(new CustomEvent('tpb:cart:changed', { detail: { cart: data } }));
        TPB.cart.verifyLater();
        return data;
      });
    },

    refresh: function () {
      var ids = cartSectionIds();
      return nativeFetch(window.location.pathname + '?sections=' + ids.join(','))
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          TPB.cart.renderSections(sections);
          TPB.cart.syncCount();
        });
    },

    renderSections: function (sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (id) {
        var html = sections[id];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        document.querySelectorAll('[data-cart-section-id="' + id + '"]').forEach(function (target) {
          var fresh = doc.querySelector('[data-cart-section-id="' + id + '"]');
          if (!fresh) return;
          var scroller = target.querySelector('[data-cart-scroll]');
          var scrollTop = scroller ? scroller.scrollTop : 0;
          target.innerHTML = fresh.innerHTML;
          var newScroller = target.querySelector('[data-cart-scroll]');
          if (newScroller) newScroller.scrollTop = scrollTop;
        });
      });
    },

    syncCount: function () {
      return TPB.cart.get().then(function (cart) {
        TPB.cart.updateCount(cart.item_count);
        TPB.cart.remember(cart);
        return cart;
      });
    },

    /* Empreinte du dernier panier affiché (nombre d'articles + total). */
    remember: function (cart) {
      if (cart && typeof cart.item_count !== 'undefined') TPB.cart.signature = cart.item_count + ':' + cart.total_price;
    },

    /* Revérifie le panier après un délai : si une app l'a modifié entre-temps
       (cadeau ajouté ou retiré automatiquement), le tiroir est re-rendu. */
    verifyLater: function (delay) {
      clearTimeout(TPB.cart._verifyTimer);
      TPB.cart._verifyTimer = setTimeout(function () {
        var before = TPB.cart.signature;
        TPB.cart.get().then(function (cart) {
          var now = cart.item_count + ':' + cart.total_price;
          if (now !== before) {
            TPB.cart.remember(cart);
            TPB.cart.refresh();
            document.dispatchEvent(new CustomEvent('tpb:cart:changed', { detail: { cart: cart, external: true } }));
          }
        });
      }, delay || 1500);
    },

    updateCount: function (count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.classList.toggle('is-empty', !count);
      });
    },

    open: function () {
      var drawer = document.querySelector('tpb-cart-drawer');
      if (drawer && config.cartType !== 'page') drawer.open();
      else window.location.href = config.routes.cart || '/cart';
    },

    close: function () {
      var drawer = document.querySelector('tpb-cart-drawer');
      if (drawer) drawer.close();
    }
  };

  /* ---------- Modifications du panier par des apps tierces ----------
     Ex. EG Auto Add to Cart ajoute/retire les produits offerts via l'Ajax Cart API :
     on resynchronise alors le tiroir et le compteur. */
  (function watchThirdPartyCart() {
    var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    var resync = TPB.debounce(function () {
      TPB.cart.refresh().then(function () {
        document.dispatchEvent(new CustomEvent('tpb:cart:changed', { detail: { external: true } }));
      });
    }, 250);

    if (window.fetch) {
      var pageFetch = window.fetch;
      window.fetch = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var req = pageFetch.apply(this, arguments);
        if (CART_RE.test(url)) req.then(function (res) { if (res && res.ok) resync(); }, function () {});
        return req;
      };
    }

    var open = XMLHttpRequest.prototype.open;
    var send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._tpbCart = CART_RE.test(String(url || ''));
      return open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this._tpbCart) {
        this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) resync(); });
      }
      return send.apply(this, arguments);
    };
  })();

  function setButtonState(btn, state) {
    if (!btn) return;
    if (state === 'loading') {
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    }
    if (state === 'added' && btn.hasAttribute('data-added-label')) {
      if (!btn.hasAttribute('data-label')) btn.setAttribute('data-label', btn.innerHTML);
      btn.innerHTML = btn.getAttribute('data-added-label');
      btn.classList.add('is-added');
    }
  }

  function showError(message, anchor) {
    var box = anchor && anchor.closest('[data-tpb-error-scope]');
    var target = box ? box.querySelector('[data-tpb-error]') : null;
    if (target) {
      target.textContent = message;
      target.hidden = false;
      setTimeout(function () { target.hidden = true; }, 5000);
    } else {
      window.alert(message);
    }
  }
  TPB.showError = showError;

  /* Boutons déclaratifs : <button data-tpb-add data-variant-id="123"> ou data-items='[{"id":1,"quantity":1}]' */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-tpb-add]');
    if (!btn) return;
    event.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    var items;
    if (btn.getAttribute('data-items')) {
      try { items = JSON.parse(btn.getAttribute('data-items')); } catch (e) { items = []; }
    } else {
      var variantId = btn.getAttribute('data-variant-id');
      var select = btn.getAttribute('data-variant-select');
      if (select) {
        var selectEl = document.getElementById(select);
        if (selectEl) variantId = selectEl.value;
      }
      items = [{ id: variantId, quantity: Number(btn.getAttribute('data-quantity') || 1) }];
    }
    items = items.filter(function (it) { return it && it.id; });
    if (!items.length) return;
    setButtonState(btn, 'loading');
    TPB.cart.add(items, { open: btn.getAttribute('data-open-cart') !== 'false' })
      .then(function () { setButtonState(btn, 'added'); })
      .catch(function (err) { setButtonState(btn, 'idle'); showError(err.message, btn); });
  });

  /* Formulaires produit Ajax */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-tpb-product-form]');
    if (!form) return;
    event.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn && btn.classList.contains('is-loading')) return;
    var fd = new FormData(form);
    var items = [{ id: fd.get('id'), quantity: Number(fd.get('quantity') || 1) }];
    var props = {};
    fd.forEach(function (value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && value) props[m[1]] = value;
    });
    if (Object.keys(props).length) items[0].properties = props;
    // Articles complémentaires cochés (ex. options d'un pack)
    form.querySelectorAll('[data-extra-item]:checked, [data-extra-item][aria-pressed="true"]').forEach(function (el) {
      var id = el.getAttribute('data-variant-id') || el.value;
      if (id) items.push({ id: id, quantity: 1 });
    });
    var detail = { items: items, form: form };
    form.dispatchEvent(new CustomEvent('tpb:product-form:submit', { bubbles: true, detail: detail }));
    setButtonState(btn, 'loading');
    TPB.cart.add(detail.items)
      .then(function () { setButtonState(btn, 'idle'); })
      .catch(function (err) { setButtonState(btn, 'idle'); showError(err.message, form); });
  });

  /* ---------- Tiroir panier ---------- */
  class TpbCartDrawer extends HTMLElement {
    connectedCallback() {
      var self = this;
      this._onKey = function (e) { if (e.key === 'Escape' && self.classList.contains('is-open')) self.close(); };
      document.addEventListener('keydown', this._onKey);
      this.addEventListener('click', function (e) {
        if (e.target.closest('[data-cart-close]')) { e.preventDefault(); self.close(); return; }
        var qtyBtn = e.target.closest('[data-cart-qty]');
        if (qtyBtn) {
          e.preventDefault();
          self.updateLine(qtyBtn, qtyBtn.getAttribute('data-key'), Number(qtyBtn.getAttribute('data-cart-qty')));
          return;
        }
        var rm = e.target.closest('[data-cart-remove]');
        if (rm) { e.preventDefault(); self.updateLine(rm, rm.getAttribute('data-key'), 0); }
      });
    }
    disconnectedCallback() { document.removeEventListener('keydown', this._onKey); }
    updateLine(btn, key, qty) {
      var line = btn.closest('[data-cart-line]');
      if (line) line.classList.add('is-updating');
      TPB.cart.change(key, qty).catch(function (err) {
        if (line) line.classList.remove('is-updating');
        showError(err.message, btn);
      });
    }
    open() {
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('tpb-lock');
      document.dispatchEvent(new CustomEvent('tpb:cart:open'));
      var closeBtn = this.querySelector('[data-cart-close]');
      if (closeBtn) setTimeout(function () { closeBtn.focus({ preventScroll: true }); }, 50);
    }
    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('tpb-lock');
      document.dispatchEvent(new CustomEvent('tpb:cart:close'));
    }
  }
  if (!customElements.get('tpb-cart-drawer')) customElements.define('tpb-cart-drawer', TpbCartDrawer);

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (!opener || config.cartType === 'page') return;
    if (!document.querySelector('tpb-cart-drawer')) return;
    e.preventDefault();
    TPB.cart.open();
  });

  /* ---------- Slider ---------- */
  class TpbSlider extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.track = this.querySelector('[data-slider-track]');
      if (!this.track) return;
      this.dotsWrap = this.querySelector('[data-slider-dots]');
      this.querySelectorAll('[data-slider-prev]').forEach(function (b) {
        b.addEventListener('click', function () { self.scrollByPage(-1); });
      });
      this.querySelectorAll('[data-slider-next]').forEach(function (b) {
        b.addEventListener('click', function () { self.scrollByPage(1); });
      });
      this.track.addEventListener('scroll', TPB.debounce(function () { self.updateDots(); }, 40), { passive: true });
      this.querySelectorAll('[data-filter]').forEach(function (pill) {
        pill.addEventListener('click', function () { self.applyFilter(pill); });
      });
      this.buildDots();
      if ('ResizeObserver' in window) {
        this._ro = new ResizeObserver(TPB.debounce(function () { self.buildDots(); }, 100));
        this._ro.observe(this.track);
      }
    }
    disconnectedCallback() { if (this._ro) this._ro.disconnect(); }
    get max() { return Math.max(0, this.track.scrollWidth - this.track.clientWidth); }
    pageCount() {
      var fixed = this.dotsWrap && Number(this.dotsWrap.getAttribute('data-count'));
      if (fixed) return fixed;
      if (!this.track.clientWidth) return 1;
      return Math.max(1, Math.min(8, Math.round(this.track.scrollWidth / this.track.clientWidth)));
    }
    buildDots() {
      if (!this.dotsWrap) return;
      var self = this;
      var n = this.max > 8 ? this.pageCount() : 0;
      this.dotsWrap.innerHTML = '';
      this.dotsWrap.hidden = n < 2;
      for (var i = 0; i < n; i++) {
        (function (index) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'tpb-dot';
          dot.setAttribute('aria-label', 'Aller à la page ' + (index + 1));
          dot.addEventListener('click', function () {
            self.track.scrollTo({ left: (self.max * index) / (n - 1), behavior: 'smooth' });
          });
          self.dotsWrap.appendChild(dot);
        })(i);
      }
      this.updateDots();
    }
    updateDots() {
      if (!this.dotsWrap) return;
      var dots = this.dotsWrap.children;
      var n = dots.length;
      if (!n) return;
      var p = this.max > 8 ? Math.round((this.track.scrollLeft / this.max) * (n - 1)) : 0;
      for (var i = 0; i < n; i++) dots[i].classList.toggle('is-active', i === p);
    }
    scrollByPage(dir) {
      this.track.scrollBy({ left: dir * this.track.clientWidth * 0.8, behavior: 'smooth' });
    }
    applyFilter(pill) {
      var value = pill.getAttribute('data-filter');
      this.querySelectorAll('[data-filter]').forEach(function (p) {
        var on = p === pill;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      this.track.querySelectorAll('[data-tags]').forEach(function (item) {
        var tags = (item.getAttribute('data-tags') || '').split(/[\s,]+/);
        item.hidden = !(value === 'all' || !value || tags.indexOf(value) >= 0);
      });
      this.track.scrollTo({ left: 0 });
      this.buildDots();
    }
  }
  if (!customElements.get('tpb-slider')) customElements.define('tpb-slider', TpbSlider);

  /* ---------- Glisser à la souris dans les sliders ----------
     Au doigt, les sliders défilent nativement ; à la souris (ordinateur, aperçu mobile
     de l'éditeur Shopify), on permet de les faire glisser en cliquant-déplaçant. */
  (function dragToScroll() {
    var SEL = '.tpb-track, .tpb-m-slide, [data-slider-track], .tpb-noscroll';
    var drag = null;
    var blockClick = false;

    document.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      var track = e.target.closest(SEL);
      if (!track || track.scrollWidth <= track.clientWidth + 2) return;
      if (e.target.closest('input, select, textarea, button, [data-no-drag]')) return;
      drag = { track: track, x: e.clientX, left: track.scrollLeft, moved: false };
    });

    document.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) < 6) return;
      if (!drag.moved) {
        drag.moved = true;
        drag.track.classList.add('is-dragging');
      }
      drag.track.scrollLeft = drag.left - dx;
      e.preventDefault();
    });

    function end() {
      if (!drag) return;
      var d = drag;
      drag = null;
      if (!d.moved) return;
      blockClick = true;
      setTimeout(function () { blockClick = false; }, 0);
      d.track.classList.remove('is-dragging');
      // Recale sur la carte la plus proche (le snap CSS est coupé pendant le glisser)
      var items = Array.prototype.filter.call(d.track.children, function (c) { return !c.hidden && c.offsetWidth; });
      var pad = parseFloat(getComputedStyle(d.track).scrollPaddingLeft) || 0;
      var best = d.track.scrollLeft, dist = Infinity;
      var origin = d.track.getBoundingClientRect().left - d.track.scrollLeft + pad;
      items.forEach(function (c) {
        var target = c.getBoundingClientRect().left - origin;
        var gap = Math.abs(target - d.track.scrollLeft);
        if (gap < dist) { dist = gap; best = target; }
      });
      d.track.scrollTo({ left: Math.max(0, best), behavior: 'smooth' });
    }
    document.addEventListener('pointerup', end);
    document.addEventListener('pointercancel', end);
    document.addEventListener('click', function (e) {
      if (blockClick) { e.preventDefault(); e.stopPropagation(); blockClick = false; }
    }, true);
    document.addEventListener('dragstart', function (e) {
      if (e.target.closest && e.target.closest(SEL)) e.preventDefault();
    });
  })();

  /* ---------- Barre collante d'ajout au panier ---------- */
  class TpbStickyAtc extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.threshold = Number(this.getAttribute('data-threshold') || 600);
      this.cartOpen = false;
      this._onScroll = function () { self.update(); };
      window.addEventListener('scroll', this._onScroll, { passive: true });
      document.addEventListener('tpb:cart:open', function () { self.cartOpen = true; self.update(); });
      document.addEventListener('tpb:cart:close', function () { self.cartOpen = false; self.update(); });
      document.body.classList.add('tpb-has-sticky-atc');
      this.update();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      document.body.classList.remove('tpb-has-sticky-atc');
    }
    update() {
      var show = (window.scrollY || 0) > this.threshold && !this.cartOpen;
      this.classList.toggle('is-visible', show);
      this.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
  }
  if (!customElements.get('tpb-sticky-atc')) customElements.define('tpb-sticky-atc', TpbStickyAtc);

  /* ---------- Estimateur de livraison ---------- */
  class TpbShippingEstimator extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.select = this.querySelector('select');
      if (!this.select) return;
      this.select.addEventListener('change', function () { self.update(); });
      this.update();
    }
    update() {
      var opt = this.select.options[this.select.selectedIndex];
      if (!opt) return;
      var min = Number(opt.getAttribute('data-min') || 2);
      var max = Number(opt.getAttribute('data-max') || 4);
      var from = this.querySelector('[data-ship-from]');
      var to = this.querySelector('[data-ship-to]');
      var note = this.querySelector('[data-ship-note]');
      if (from) from.textContent = TPB.frDate(TPB.addWorkingDays(min));
      if (to) to.textContent = TPB.frDate(TPB.addWorkingDays(max));
      if (note) note.textContent = opt.getAttribute('data-note') || '';
    }
  }
  if (!customElements.get('tpb-shipping-estimator')) customElements.define('tpb-shipping-estimator', TpbShippingEstimator);

  /* ---------- Header : menu mobile + menus déroulants ---------- */
  class TpbHeader extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.addEventListener('click', function (e) {
        var toggle = e.target.closest('[data-menu-toggle]');
        if (toggle) { e.preventDefault(); self.toggleMenu(); return; }
        var sub = e.target.closest('[data-submenu-toggle]');
        if (sub) {
          e.preventDefault();
          var panel = document.getElementById(sub.getAttribute('aria-controls'));
          var open = sub.getAttribute('aria-expanded') !== 'true';
          sub.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (panel) panel.hidden = !open;
        }
      });
      document.addEventListener('click', function (e) {
        self.querySelectorAll('details[data-dropdown][open]').forEach(function (d) {
          if (!d.contains(e.target)) d.removeAttribute('open');
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        self.querySelectorAll('details[data-dropdown][open]').forEach(function (d) { d.removeAttribute('open'); });
        if (self.classList.contains('menu-open')) self.toggleMenu(false);
      });
    }
    toggleMenu(force) {
      var open = typeof force === 'boolean' ? force : !this.classList.contains('menu-open');
      this.classList.toggle('menu-open', open);
      var btn = this.querySelector('[data-menu-toggle]');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var panel = this.querySelector('[data-mobile-menu]');
      if (panel) panel.hidden = !open;
    }
  }
  if (!customElements.get('tpb-header')) customElements.define('tpb-header', TpbHeader);

  /* ---------- Accordéons exclusifs (data-accordion-group) ---------- */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.open) return;
    var group = d.getAttribute('data-accordion-group');
    if (!group) return;
    document.querySelectorAll('details[data-accordion-group="' + group + '"][open]').forEach(function (other) {
      if (other !== d) other.removeAttribute('open');
    });
  }, true);

  /* ---------- Éditeur de thème ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-cart-section-id]')) TPB.cart.syncCount();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target;
    var track = slide.closest('[data-slider-track]');
    if (track) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    if (slide.tagName === 'DETAILS') slide.setAttribute('open', '');
  });
})();
